import React, { useMemo } from "react";

import { DefaultAvatar } from "~/images";

import { CDNImage, ImageVariant } from "./cdnImage";

export interface UserAvatarProps {
  avatar?: string;
  variant?: ImageVariant | "XS";
}

export const UserAvatar: React.FC<UserAvatarProps> = ({
  avatar,
  variant = ImageVariant.SmallThumbnail,
}) => {
  const sizeProps = useMemo(() => {
    switch (variant) {
      case "XS":
        return { width: 25, height: 25 };
      case ImageVariant.SmallThumbnail:
        return { width: 35, height: 35 };
      case ImageVariant.MediumThumbnail:
        return { width: 50, height: 50 };
      case ImageVariant.LargeThumbnail:
        return { width: 75, height: 75 };
      case ImageVariant.XLThumbnail:
        return { width: 100, height: 100 };
      default:
        return {};
    }
  }, [variant]);
  return (
    <>
      {avatar ? (
        <CDNImage
          className="avatar"
          variant={variant !== "XS" ? variant : ImageVariant.SmallThumbnail}
          imageId={avatar}
          style={{ ...sizeProps }}
        />
      ) : (
        <img
          className="avatar"
          alt="avatar"
          src={DefaultAvatar}
          {...sizeProps}
        />
      )}
    </>
  );
};
